module.exports = __webpack_public_path__ + "static/media/7.23.5d2f2162.png";